// src/pages/Home.jsx
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence, useInView } from "framer-motion";
import { Container, Row, Col, Button } from "reactstrap";
import {
  FiCode, FiCloud, FiShield, FiHeadphones, FiBriefcase, FiUsers, FiZap, FiEye, FiHeart, FiTarget, FiDollarSign, FiGlobe, FiCheckCircle,
  FiBookOpen, FiMonitor, FiLock, FiWifi, FiServer, FiArrowUpRight, FiTrendingUp, FiStar,
  FiLayers, FiBarChart, FiAward,
} from "react-icons/fi";
import { RiTestTubeFill } from "react-icons/ri";
import { FaWrench } from "react-icons/fa";
import { BsRocketFill } from "react-icons/bs";
import { IoBarChart, IoSparklesSharp } from "react-icons/io5";
import { globeicon } from "../../theme/images";
import { LuQuote } from "react-icons/lu";
import { useLocation } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [activeService, setActiveService] = useState(0);
  const location = useLocation();

 useEffect(() => {
  // If URL has a hash → scroll to that section
  if (location.hash) {
    const element = document.querySelector(location.hash);

    if (element) {
      // small delay so page content is rendered
      setTimeout(() => {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  } else {
    // No hash → always scroll to top when landing on Home
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // use "smooth" if you prefer
    });
  }
}, [location.pathname, location.hash]);
  // const Marquee = ({ items, speed = 25, reverse = false }) => {
  //   return (
  //     <div className="home-marquee-wrapper overflow-hidden position-relative">
  //       {/* Gradient Fade Edges */}
  //       <div className="home-marquee-fade-left" />
  //       <div className="home-marquee-fade-right" />

  //       <motion.div
  //         className="home-marquee-track d-flex gap-4"
  //         animate={{
  //           x: reverse ? ["0%", "-50%"] : ["-50%", "0%"]
  //         }}
  //         transition={{
  //           duration: speed,
  //           repeat: Infinity,
  //           ease: "linear",
  //           repeatType: "loop"     // This prevents jumping
  //         }}
  //       >
  //         {[...items, ...items].map((item, i) => (
  //           <div
  //             key={i}
  //             className="home-tech-pill d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill border bg-white shadow-sm text-muted fw-medium"
  //           >
  //             <div className="home-tech-dot" />
  //             {item}
  //           </div>
  //         ))}
  //       </motion.div>
  //     </div>
  //   );
  // };
  const CornerCircles = () => (
    <>
      <span className="corner-circle top-right" />
      <span className="corner-circle bottom-left" />
    </>
  );

  const AnimatedSection = ({
    children,
    className = "",
    delay = 0,
    direction = "up"
  }) => {

    const ref = useRef(null);
    const isInView = useInView(ref, {
      once: false,
      margin: "-60px"
    });

    // Define initial position based on direction
    const getInitial = () => {
      if (direction === "left") return { opacity: 0, x: -60 };
      if (direction === "right") return { opacity: 0, x: 60 };
      return { opacity: 0, y: 50 }; // default "up"
    };

    return (
      <motion.div
        ref={ref}
        initial={getInitial()}
        animate={isInView ? { opacity: 1, x: 0, y: 0 } : getInitial()}
        transition={{
          duration: 0.7,
          delay,
          ease: [0.25, 0.46, 0.45, 0.94]
        }}
        className={className}
      >
        {children}
      </motion.div>
    );
  };




  const techStack = ["React", "Angular", "Node.js", "Python", "AWS", "Azure", "Docker", "Kubernetes", "TypeScript", "Java", "Spring Boot", ".NET", "PostgreSQL", "MongoDB", "Redis", "GraphQL"];
  // const roles = ["Full Stack Developer", "DevOps Engineer", "QA Analyst", "UI/UX Designer", "Data Engineer", "Cloud Architect", "Product Manager", "Scrum Master", "Security Analyst", "Mobile Developer"];

  const services = [
    {
      num: "01",
      title: "New Product Development",
      desc: "In a dynamic business scenario, the most critical factor that holds the key to retain market leadership is your ability to launch and develop new products.",
      icon: FiCode,
      link: "/services/new-product-development"
    },
    {
      num: "02",
      title: "Product Support Services",
      desc: "Our Product Support Services will help clients extend the life of core products, improve the performance of core and amplify market relevance, revenue potential, and profitability.",
      icon: FiHeadphones,
      link: "/services/product-support-services"
    },
    {
      num: "03",
      title: "Cloud Solutions",
      desc: "With the movement towards a multi or hybrid cloud environment using public cloud platforms such as AWS, Azure or an Enterprise Level private cloud platform; there is a huge surge for cloud migration services.",
      icon: FiCloud,
      link: "/services/cloud-solutions"
    },
    {
      num: "04",
      title: "Quality Assurance Services",
      desc: "Our entire workforce comprises industry-certified professionals who know tricks of the trade through experience and theory, giving us the sharp edge of knowledge and its correct application.",
      icon: RiTestTubeFill,
      link: "/services/new-product-development"
    },
    {
      num: "05",
      title: "Managed Security",
      desc: "24x7 Monitoring potential threats, compliance violations or vulnerability using a Security Platform and triage the alerts.",
      icon: FiShield,
      link: "/services/cloud-solutions"
    },
  ];

  const challenges = [
    {
      title: "Availability",
      desc: "Finding the right talent to innovate quickly, at a cost that’s optimal is key. There is shortage of highly talented software developers in Europe and US.",
      icon: FiUsers
    },
    {
      title: "Scalability",
      desc: "Managing the scalability of team in-line with business growth. Quick Ramp-up.",
      icon: BsRocketFill
    },
    {
      title: "Innovation",
      desc: "Ability to innovate, lack of talent with global tech ecosystem and market experience.",
      icon: FiZap
    },
    {
      title: "Control & Transparency",
      desc: "Control and Transparency about the resources, quality and work schedule is lost when work is outsourced.",
      icon: FiEye
    },
    {
      title: "Culture",
      desc: "Outsourcing partner in different country, different corporate culture, not aligned with our values.",
      icon: FiHeart
    },
  ];

  const offshoreFeatures = [
    {
      num: "01",
      title: "Fully Dedicated Employees",
      desc: "Dedicated employees who think about your products and services, long-term perspective.",
      icon: FiUsers
    },
    {
      num: "02",
      title: "Lower Cost of Ownership",
      desc: "Super attractive Cost-Plus model, to reduce the total cost of operation of these offshore offices.",
      icon: FiDollarSign
    },
    {
      num: "03",
      title: "Extension of your Team",
      desc: "It’s a cross-continent extension of your existing team. Work with them as you do with your developers at home.",
      icon: FiGlobe
    },
    {
      num: "04",
      title: "Same Dev Tools",
      desc: "Offshore Office Team will use same Dev tools, Collaboration & communication platforms of your team.",
      icon: FaWrench
    },
    {
      num: "05",
      title: "Scale Quickly",
      desc: "A fiscally attractive solution to get the talent you need to scale quickly, not found locally.",
      icon: BsRocketFill
    },
    {
      num: "06",
      title: "Quality of Hiring",
      desc: "Developers are hand-picked in line with your specific requirements with the final hiring decision made by you.",
      icon: FiAward
    },
  ];

  const howItWorks = [
    {
      step: "01",
      title: "Strategy Definition",
      desc: "Getting to know offshore partner & signing contract",
      icon: FiTarget
    },
    {
      step: "02",
      title: "Interview Process",
      desc: "Rigorous candidate screening and selection",
      icon: FiUsers
    },
    {
      step: "03",
      title: "Onboarding",
      desc: "Seamless integration into your workflow",
      icon: FiBookOpen
    },
    {
      step: "04",
      title: "Setting Up Office",
      desc: "Local office and workplace setup",
      icon: FiMonitor
    },
    {
      step: "05",
      title: "Define SOP",
      desc: "Standard operating procedures established",
      icon: FiLayers
    },
    {
      step: "06",
      title: "Joint Delivery",
      desc: "Orientation for collaborative delivery",
      icon: FiBriefcase
    },
    {
      step: "07",
      title: "Ongoing Monitoring",
      desc: "Continuous performance tracking",
      icon: FiBarChart
    },
    {
      step: "08",
      title: "Maturity & Scale",
      desc: "Growth and expansion phase",
      icon: BsRocketFill
    },
  ];

  const securityPillars = [
    {
      color: "green",
      title: "Access Control",
      items: [
        "Fully enclosed offshore office with physical separation",
        "Each Engineer signs Customer and SpringUp Labs NDA",
        "Access to Customer servers only through offshore VLAN"
      ],
      icon: FiLock,
      gradient: "#b62b9fff"
    },
    {
      color: "blue",
      title: "Connectivity Controls",
      items: [
        "Secured VPN connectivity to Customer network",
        "Two Factor Authentication",
        "Secured VLAN and IP-Configuration"
      ],
      icon: FiWifi,
      gradient: "from-secondary to-secondary/70"
    },
    {
      color: "purple",
      title: "Network Controls",
      items: [
        "Dedicated VLAN network with dedicated Static IP",
        "Flexibility to implement customer IT Policies",
        "Dedicated Server room with restricted access"
      ],
      icon: FiServer,
      gradient: "from-primary to-secondary"
    },
  ];
  const whyUs = [
    "Fully managed operations — we do your heavy lifting.",
    "A focus on cultural alignment and buy in to your vision and mission.",
    "Your developers are 100% dedicated to you.",
    "On-demand scaling as and when you want to increase capacity.",
    "European/US organization combined with Indian engineering talent.",
    "Founded by a team with decades of offshoring experience.",
    "Alignment to Customer Policies, Procedures, and Culture.",
  ];

  const caseStudies = [
    { title: "German Edtech Company", tag: "Case Study 1", industry: "Education", result: "25+ Engineers Deployed" },
    { title: "Norwegian IT Services Company", tag: "Case Study 2", industry: "IT Services", result: "3x Faster Delivery" },
    { title: "Berlin Based Proptech Company", tag: "Case Study 3", industry: "PropTech", result: "40% Cost Reduction" },
    { title: "US Based Startup", tag: "Case Study 4", industry: "SaaS", result: "MVP in 3 Months" },
    { title: "Norway Based Startup", tag: "Case Study 5", industry: "FinTech", result: "10+ Engineers Scaled" },
    { title: "Sweden Based Tech Startup", tag: "Case Study 6", industry: "HealthTech", result: "Full Product Team" },
  ];

  // Auto-rotate services
  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setActiveService(prev => (prev + 1) % services.length);
  //   }, 4000);
  //   return () => clearInterval(timer);
  // }, [services.length]);

  // Reusable Counter Component with Scroll Trigger
  const Counter = ({ target, suffix = "", duration = 5000 }) => {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-50px" });

    useEffect(() => {
      if (!isInView) return;

      let start = 0;
      const increment = Math.ceil(target / (duration / 16)); // smooth increment
      const timer = setInterval(() => {
        start += increment;
        if (start >= target) {
          setCount(target);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 16);

      return () => clearInterval(timer);
    }, [isInView, target, duration]);

    return (
      <span ref={ref} className="home-stat-number">
        {count}{suffix}
      </span>
    );
  };


  return (
    <div className="home-page">
      {/* HERO SECTION - Exact Match to Your Image */}
      <section className="home-hero position-relative overflow-hidden d-flex align-items-center">

        {/* Soft Light Background */}
        <div className="home-hero-bg" />

        {/* Subtle Blobs for depth */}
        <div className="home-hero-blob-1" />
        <div className="home-hero-blob-2" />

        <Container className="position-relative">
          <Row className="align-items-center g-5">
            {/* Left Side - Text Content */}
            <Col lg={7}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                {/* Badge */}
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  <span className="home-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-4">
                    <span className="home-badge-icon"></span>
                    Fostering Innovation & Driving Quality
                  </span>
                </motion.div>

                {/* Main Heading */}
                <h1 className="home-hero-title fw-bold mb-4">
                  Digital Engineering through{" "}
                  <span className="home-highlight-text">Value Driven, Customer Focused</span>{" "}
                  Lean Thinking!
                </h1>

                {/* Subtitle */}
                <p className="home-hero-subtitle mb-5">
                  We are an innovative software product development company focusing on modern digital capabilities and data-driven methodologies to enhance efficiency and value.
                </p>

                {/* Buttons */}
                <div className="d-flex flex-wrap gap-3">
                  {/* <Link to="/contact"> */}
                  <Button tag={Link}
                    to="/contact" outline size="" className="home-cta-primary px-5 py-3 rounded-pill fw-semibold d-flex align-items-center gap-2">
                    Connect with us →
                  </Button>
                  {/* </Link> */}
                  {/* <Link to="/services">
                    <Button outline size="" className="home-cta-secondary px-5 py-3 rounded-pill fw-semibold">
                      Our Services
                    </Button>
                  </Link> */}
                </div>

                {/* Stats */}
                {/* Attractive Stats Section */}
                <motion.div
                  className="home-stats mt-5"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6 }}
                >
                  <div className="home-stats-container">
                    {[
                      { value: "07+", label: "Countries" },
                      { value: "150+", label: "Headcount" },
                      { value: "40+", label: "Satisfied Clients" },
                    ].map((stat, i) => (
                      <motion.div
                        key={i}
                        className="home-stat-card"
                        initial={{ opacity: 0, y: 40, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{
                          delay: 0.7 + i * 0.12,
                          duration: 0.7,
                          ease: "easeOut"
                        }}
                        whileHover={{
                          scale: 1.08,
                          y: -8,
                          transition: { duration: 0.3 }
                        }}
                      >
                        <div className="home-stat-value">{stat.value}</div>
                        <div className="home-stat-label2 ">{stat.label}</div>
                      </motion.div>
                    ))}
                  </div>
                </motion.div>
              </motion.div>
            </Col>
            {/* Right Side - Floating Elements */}
            <Col lg={5} className="d-none d-lg-block">
              <div className="home-floating-area position-relative">

                {/* Concentric Dashed Circles */}
                <div className="home-ring-outer" />
                <div className="home-ring-inner" />

                {/* Floating Cards - Carefully positioned to avoid overlap */}
                {[
                  { icon: FiCode, label: "Product Dev", top: "8%", left: "10%" },
                  { icon: FiCloud, label: "Cloud", top: "22%", right: "8%" },
                  { icon: FiShield, label: "Security", bottom: "32%", left: "6%" },
                  { icon: FiShield, label: "QA", bottom: "18%", right: "10%" },
                  { icon: FiHeadphones, label: "Support", top: "48%", right: "6%" },
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    className="home-floating-card"
                    style={{
                      top: item.top,
                      left: item.left,
                      right: item.right,
                      bottom: item.bottom
                    }}
                    initial={{ opacity: 0, scale: 0.6, y: 30 }}
                    animate={{
                      opacity: 1,
                      scale: 1,
                      y: [0, -14, 0]
                    }}
                    transition={{
                      duration: 3.8,
                      repeat: Infinity,
                      delay: index * 0.25,
                      ease: "easeInOut"
                    }}
                  >
                    <div className="home-floating-card-content">
                      <div className="home-floating-icon-wrapper">
                        <item.icon size={24} className="home-floating-icon" />
                      </div>
                      <span className="home-floating-label">{item.label}</span>
                    </div>
                  </motion.div>
                ))}

                {/* Center SU Logo */}
                <motion.div
                  className="home-center-globe"
                  initial={{ scale: 0.6, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.7, type: "spring", stiffness: 100 }}
                >
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 28, repeat: Infinity, ease: "linear" }}
                    className="home-globe-wrapper"
                  >
                    <img
                      src={globeicon}
                      alt="Software University"
                      className="home-globe-img"
                    />
                  </motion.div>
                </motion.div>

              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== TECH STACK MARQUEE ===== */}
      <section className="home-tech-marquee py-5 border-top border-bottom bg-light">
        <Container fluid>
          <div className="text-center mb-4">
            <p className="home-tech-title text-uppercase fw-semibold tracking-widest text-muted small">
              Technologies We Work With
            </p>
          </div>

          {/* Completely Isolated Marquee */}
          <div className="home-marquee-wrapper overflow-hidden position-relative">
            <div className="home-marquee-fade-left" />
            <div className="home-marquee-fade-right" />

            <motion.div
              className="home-marquee-track d-flex gap-4"
              animate={{
                x: ["-50%", "0%"]
              }}
              transition={{
                duration: 25,           // You can adjust speed here
                repeat: Infinity,
                ease: "linear",
                repeatType: "loop"
              }}
            >
              {[...techStack, ...techStack].map((item, i) => (
                <div
                  key={i}
                  className="home-tech-pill d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill border bg-white shadow-sm text-muted fw-medium"
                >
                  <div className="home-tech-dot" />
                  {item}
                </div>
              ))}
            </motion.div>
          </div>
        </Container>
      </section>

      {/* ===== WHO WE ARE ===== */}
      <section className="home-who-we-are py-5 py-lg-6 position-relative overflow-hidden ">
        <Container>
          <div className="text-center mb-5">
            <div className="home-who-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <FiStar size={16} /> Who We Are
            </div>
            <h2 className="home-who-title fw-bold mb-3">
              Your Trusted{" "}
              <span className="home-highlight">Technology Partner</span>
            </h2>
            <p className="home-who-subtitle text-muted mx-auto" style={{ maxWidth: "680px" }}>
              Our identity encompasses more than a tech company. We are an innovative software product development company focusing on modern digital capabilities and data-driven methodologies to enhance efficiency and value.
            </p>
          </div>

          <Row className="g-5 align-items-start">
            {/* Left - Description Card */}
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ duration: 0.7 }}
                whileHover={{ scale: 1.02 }}
                className="home-description-card position-relative rounded-4 overflow-hidden p-5 p-lg-6 h-100"
              >
                {/* Background Decorations */}
                <div className="home-card-bg-circle-1" />
                <div className="home-card-bg-circle-2" />
                <div className="home-card-grid" />

                <div className="position-relative z-10">
                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    className="home-year-badge d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-4"
                  >
                    <IoSparklesSharp size={14} /> Since 2021
                  </motion.div>

                  <h3 className="home-description-title fw-bold mb-4">
                    We help customers realize their investments through{" "}
                    <span className="home-description-highlight">digital transformation</span>
                  </h3>

                  <p className="home-description-text text-muted">
                    Working with customer focus, integrity, and insight — we become the trusted technology partner in our customers' digital transformation journey, delivering measurable outcomes.
                  </p>
                </div>

                <Link
                  to="/about"
                  className="home-learn-more-link d-inline-flex align-items-center gap-2 mt-5 fw-semibold"
                >
                  Learn more about us <span>→</span>
                </Link>
              </motion.div>
            </Col>

            {/* Right - Core Values Grid */}
            <Col lg={6}>
              <Row className="g-4">
                {[
                  { icon: FiHeart, title: "Customer Focused", desc: "Deep understanding of client needs drives every solution we build" },
                  { icon: FiUsers, title: "People First", desc: "Empowering our team to innovate and grow together" },
                  { icon: FiShield, title: "Trust & Integrity", desc: "Transparent partnerships built on honesty and reliability" },
                  { icon: FiTrendingUp, title: "Value Generation", desc: "Maximizing ROI through efficient and scalable solutions" },
                ].map((value, i) => (
                  <Col key={i} sm={6}>
                    <motion.div
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: false }}
                      transition={{ delay: 0.2 + i * 0.1 }}
                      whileHover={{ y: -6, scale: 1.02 }}
                      className="home-value-card h-100 p-4 rounded-4 border text-center"
                    >
                      <div className="home-value-icon-wrapper mx-auto mb-4">
                        <value.icon size={27} />
                      </div>
                      <h4 className="home-value-title fw-semibold mb-3">{value.title}</h4>
                      {/* <p className="home-value-desc text-muted small">{value.desc}</p> */}
                    </motion.div>
                  </Col>
                ))}
              </Row>

              {/* Passion & Empathy Pills */}
              <div className="d-flex flex-wrap gap-2 mt-4">
                {["Passion & Empathy", "Continuous Learning", "Innovation Mindset", "Agile Methodology"].map((v, i) => (
                  <motion.span
                    key={v}
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.5 + i * 0.08 }}
                    whileHover={{ scale: 1.05 }}
                    className="home-passion-pill px-4 py-2 rounded-pill border bg-white text-muted small fw-medium"
                  >
                    {v}
                  </motion.span>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ===== WHAT WE OFFER — Interactive Services ===== */}
      <section className="home-what-we-offer py-5 py-lg-6 position-relative overflow-hidden bg-light">
        <Container>
          <AnimatedSection>
            <div className="text-center mb-5">
              <div className="home-offer-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
                <FiBriefcase size={16} /> Our Services
              </div>
              <h2 className="home-offer-title fw-bold mb-3">
                What We <span className="home-highlight">Offer</span>
              </h2>
              <p className="home-offer-subtitle text-muted mx-auto" style={{ maxWidth: "620px" }}>
                End-to-end software development solutions tailored to accelerate your digital transformation journey.
              </p>
            </div>
          </AnimatedSection>

          <Row className="g-4 align-items-start">
            {/* Service Tabs (Left Side) */}
            <Col lg={5}>
              <div className="home-services-tabs">
                {services.map((s, i) => (
                  // <AnimatedSection key={s.num} delay={i * 0.06} direction="left">
                  <motion.div
                    onClick={() => setActiveService(i)}
                    whileHover={{ x: 6 }}
                    className={`home-service-tab ${activeService === i ? 'active' : ''}`}
                  >
                    <div className={`home-service-icon ${activeService === i ? 'active' : ''}`}>
                      <s.icon size={24} />
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5 className="home-service-title mb-0">{s.title}</h5>
                        <span className="home-service-num">{s.num}</span>
                      </div>
                      {activeService === i && (
                        <motion.p
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: 'auto' }}
                          exit={{ opacity: 0, height: 0 }}
                          className="home-service-desc mt-2 mb-0"
                        >
                          {s.desc}
                        </motion.p>
                      )}
                    </div>
                  </motion.div>
                  // </AnimatedSection>
                ))}
              </div>
            </Col>

            {/* Active Service Showcase (Right Side) */}
            <Col lg={7} className="d-flex align-items-center justify-content-center">
              {/* <AnimatedSection direction="right" delay={0.2}> */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeService}
                  initial={{ opacity: 0, scale: 0.96 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.96 }}
                  transition={{ duration: 0.4 }}
                  className="home-service-showcase position-relative rounded-4 overflow-hidden border shadow-sm "
                >
                  {/* Decorative Background */}
                  <div className="home-service-bg-overlay" />
                  <div className="home-service-bg-corner" />

                  <div className="p-4 p-lg-5 h-100 d-flex flex-column justify-content-between">
                    <div>
                      <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        className="home-service-showcase-icon mb-4"
                      >
                        {React.createElement(services[activeService].icon, { size: 42 })}
                      </motion.div>

                      <span className="home-service-showcase-num">
                        {services[activeService].num}
                      </span>

                      <h3 className="home-service-showcase-title fw-bold mt-2 mb-3">
                        {services[activeService].title}
                      </h3>

                      <p className="home-service-showcase-desc text-muted">
                        {services[activeService].desc}
                      </p>
                    </div>

                    <Link
                      to={services[activeService].link}
                      className="home-service-learn-more d-inline-flex align-items-center gap-2 mt-4"
                    >
                      Learn More <span>→</span>
                    </Link>
                  </div>

                  {/* Progress Dots */}
                  <div className="home-progress-dots">
                    {services.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setActiveService(i)}
                        className={`home-progress-dot ${i === activeService ? 'active' : ''}`}
                      />
                    ))}
                  </div>
                </motion.div>
              </AnimatePresence>
              {/* </AnimatedSection> */}
            </Col>
          </Row>
        </Container>
      </section>


      {/* <section className="home-tech-marquee py-5 border-top border-bottom bg-light">
        <Container fluid>
          <div className="text-center mb-4">
            <p className="home-tech-title text-uppercase fw-semibold tracking-widest text-muted small">
              Technologies We Work With
            </p>
          </div>

          <Marquee items={roles} speed={35} reverse />
        </Container>
      </section> */}

      {/* ===== CHALLENGES SECTION ===== */}
      <section className="home-challenges py-5 py-lg-6 position-relative overflow-hidden bg-light">
        <Container>
          <div className="text-center mb-5">
            <div className="home-challenges-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <FiTarget size={16} /> Common Obstacles
            </div>
            <h2 className="home-challenges-title fw-bold mb-3">
              Challenges In{" "}
              <span className="home-highlight">Growing Your Business</span>
            </h2>
          </div>

          {/* <div className="home-challenges-grid">
            {challenges.map((c, i) => (
              // <AnimatedSection key={i} delay={i * 0.08}>
              <motion.div
                whileHover={{ y: -10, scale: 1.03 }}
                className="home-challenge-card"
              >
                <div className="home-challenge-icon-wrapper mb-4">
                  <c.icon size={30} />
                </div>
                <h4 className="home-challenge-title fw-semibold mb-3">{c.title}</h4>
                <p className="home-challenge-desc text-muted text">{c.desc}</p>
              </motion.div>
              // </AnimatedSection>
            ))}
          </div> */}
          <motion.div
            className="aicoe-mode-steps"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}

          >
            {challenges.map((c, i) => (
              <motion.div key={c.num} className="aicoe-mode-step" >
                <CornerCircles />
                <div className="aicoe-mode-num"> <c.icon size={30} /></div>
                <h4>{c.title}</h4>
                <p>{c.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </Container>
      </section>

      {/* ===== OFFSHORE OFFICE MODEL ===== */}
      <section className="home-offshore-model py-5 py-lg-6 position-relative overflow-hidden " id="challenges">
        <Container>
          <div className="text-center mb-5">
            <div className="home-offshore-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <FiGlobe size={16} /> Our Model
            </div>
            <h2 className="home-offshore-title fw-bold mb-3">
              Introducing{" "}
              <span className="home-highlight">Offshore Office Model</span>
            </h2>
            <p className="home-offshore-subtitle text-muted mx-auto" style={{ maxWidth: "520px" }}>
              Your own offshore team — not outsourcing!
            </p>
          </div>

          {/* Advantages Grid - Light Cards like in Image */}
          <Row className="g-4 mb-5">
            {[
              { title: "Lower Operating Cost", desc: "It's far less expensive to build teams in emerging tech nations like India than in metropolitan hotspots across US & Europe." },
              { title: "Access to Talent", desc: "Business experience to support innovation. India produces over a million new developers every single year, with fluent English and elite, world renowned technical skills." },
              { title: "Complete Transparency", desc: "Team Members to be selected through interview process, work closely with the existing engineering team." },
              { title: "Opportunity to Scale", desc: "With a reliable offshoring partner, scaling is simple. You can expand premises and recruit any role without the usual financial risk or operational disruption." },
            ].map((advantage, i) => (
              <Col key={i} sm={6} lg={3}>
                {/* <AnimatedSection delay={i * 0.08}> */}
                <motion.div
                  whileHover={{ y: -6 }}
                  className="home-advantage-card h-100"
                >
                  <div className="home-advantage-check mb-3">
                    <FiCheckCircle size={28} />
                  </div>
                  <h5 className="home-advantage-title fw-semibold mb-3">{advantage.title}</h5>
                  <p className="home-advantage-desc text-muted">{advantage.desc}</p>
                </motion.div>
                {/* </AnimatedSection> */}
              </Col>
            ))}
          </Row>

          {/* Not Outsourcing Banner - Exact Style from Image */}
          <div className="mb-5">
            <motion.div
              whileHover={{ scale: 1.01 }}
              className="home-not-outsourcing-banner text-center py-4 px-5 "
            >
              <p className="home-not-outsourcing-text fw-bold mb-0">
                This is <span className="home-strike">not outsourcing</span> or offshoring —
                It's your own <span className="home-offshore-highlight">Offshore Office</span>
              </p>
            </motion.div>
          </div >

          {/* Features Grid - Bottom Cards */}
          {/* <Row className="g-4">
            {offshoreFeatures.map((f, i) => (
              <Col key={i} sm={6} lg={4}>
             
                <motion.div
                  whileHover={{ y: -10 }}
                  className="home-feature-card h-100 text-center p-4 rounded-4 border position-relative overflow-hidden"
                >
               
                  <div className="home-feature-top-bar" />

                
                  <div className="home-feature-icon-wrapper mx-auto mb-4">
                    <f.icon size={36} />
                  </div>

                  <h4 className="home-feature-title fw-semibold mb-3">{f.title}</h4>
                  <p className="home-feature-desc text-muted">{f.desc}</p>
                </motion.div>
              
              </Col>
            ))}
          </Row> */}
          <motion.div
            className="home-offshore-solutions-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
          // variants={stagger}
          >
            {offshoreFeatures.map((f, i) => {
              const s = f;
              const Icon = s.icon;
              return (
                <motion.div key={s.num} className="aicoe-sol-card" >
                  <CornerCircles />
                  <span className="aicoe-sol-number">{s.num}</span>
                  <div className="aicoe-sol-icon">
                    <Icon />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </motion.div>
              );
            })}
          </motion.div>

        </Container>
      </section>

      {/* ===== HOW IT WORKS — Horizontal scroll timeline ===== */}
      <section className="home-how-it-works py-5 py-lg-6 position-relative overflow-hidden bg-light">
        <Container>
          <div className="text-center mb-5">
            <div className="home-how-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <FiLayers size={16} /> Process
            </div>
            <h2 className="home-how-title fw-bold mb-3">
              How It <span className="home-highlight">Works?</span>
            </h2>
          </div>

          {/* Timeline */}
          <div className="position-relative">
            {/* Connection Line */}
            <div className="home-timeline-line" />

            <Row className="g-4">
              {howItWorks.map((step, i) => (
                <Col key={i} sm={6} md={4} lg={3}>
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false }}
                    transition={{ duration: 0.6, delay: i * 0.08 }}
                    whileHover={{ y: -12 }}
                    className="home-how-step text-center position-relative"
                  >
                    {/* Step Circle */}
                    <div className="home-step-circle-wrapper mx-auto mb-4">
                      <motion.div
                        whileHover={{ scale: 1.15, rotate: 8 }}
                        className="home-step-circle"
                      >
                        <step.icon size={28} />
                      </motion.div>

                      {/* Step Number Badge */}
                      <div className="home-step-number">
                        {step.step}
                      </div>
                    </div>

                    <h4 className="home-step-title fw-semibold mb-2">{step.title}</h4>
                    <p className="home-step-desc text-muted small">{step.desc}</p>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </section>

      {/* ===== ACCESS CONTROL & DATA SECURITY ===== */}
      <section className="home-security-section py-5 py-lg-6  position-relative overflow-hidden">
        <Container>
          <div className="text-center mb-5">
            <div className="home-security-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <FiShield size={16} /> Security
            </div>
            <h2 className="home-security-title fw-bold mb-3">
              Access Control &{" "}
              <span className="home-highlight">Data Security</span>
            </h2>
          </div>

          {/* <Row className="g-4">
            {securityPillars.map((p, i) => (
              <Col key={i} md={6} lg={4}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ duration: 0.6, delay: i * 0.12 }}
                  whileHover={{ y: -8 }}
                  className="home-security-card h-100 position-relative overflow-hidden border rounded-4 p-4 p-lg-5"
                >
                  
                  <div className="home-security-top-bar" />
                 
                  <div className="home-security-icon-wrapper mb-4">
                    <p.icon size={36} />
                  </div>

                  <h3 className="home-security-title-card fw-bold mb-4">{p.title}</h3>

                  <ul className="home-security-list">
                    {p.items.map((item, idx) => (
                      <li key={idx} className="d-flex align-items-start gap-3 mb-3">
                        <FiCheckCircle size={18} className="text-success mt-1 flex-shrink-0" />
                        <span className="text-muted small">{item}</span>
                      </li>
                    ))}
                  </ul>
                </motion.div>
              </Col>
            ))}
          </Row> */}
          <Row className="g-4">
            {securityPillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <Col key={i} md={6} lg={4}>
                  <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ duration: 0.6, delay: i * 0.12 }}
                    whileHover={{ y: -10 }}
                    className={`security-card ${p.color || 'green'}`}
                  >
                    <CornerCircles />

                    {/* Bottom Glow */}
                    <div className="security-card-glow" />

                    <div className="security-card-body">
                      {/* Colored Icon */}
                      <div className={`security-icon ${p.color || 'green'}`}>
                        <Icon size={34} color="#fff" />
                      </div>

                      <h3 className="security-title">{p.title}</h3>

                      <ul className="security-list">
                        {p.items.map((item, idx) => (
                          <li key={idx} className="d-flex align-items-start gap-3 mb-3">
                            <FiCheckCircle size={18} className="text-success mt-1 flex-shrink-0" />
                            <span className="text-muted small">{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>


      {/* ===== WHY US SECTION ===== */}
      <section className="home-why-us py-5 py-lg-6 position-relative overflow-hidden bg-light">
        <Container>
          <Row className="align-items-center g-5">
            {/* Left Side - List */}
            <Col lg={6}>
              <div className="mb-4">
                <div className="home-why-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
                  <FiAward size={16} /> Why Us
                </div>
                <h2 className="home-why-title fw-bold mb-3">
                  Why{" "}
                  <span className="home-highlight">SpringUp Labs</span>
                </h2>
                <p className="home-why-subtitle text-muted">
                  From 2 to 25+ engineers, we build world-class development teams.
                  Beat the tech talent shortage at home and accelerate your innovation.
                </p>
              </div>

              <ul className="home-why-list">
                {whyUs.map((item, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false }}
                    transition={{ delay: i * 0.08 }}
                    whileHover={{ x: 10 }}
                    className="home-why-list-item d-flex align-items-start gap-3 p-3 rounded-3"
                  >
                    <div className="home-why-check">
                      <FiCheckCircle size={20} />
                    </div>
                    <span className="home-why-text">{item}</span>
                  </motion.li>
                ))}
              </ul>
            </Col>

            {/* Right Side - Testimonial Card + Floating Stat */}
            <Col lg={6}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                whileHover={{ rotate: -2 }}
                className="home-testimonial-card position-relative rounded-4 border p-5 p-lg-6 shadow-sm"
              >
                <div className="home-testimonial-bg" />

                <LuQuote size={48} className="home-quote-icon mb-4" />

                <p className="home-testimonial-text fst-italic mb-5">
                  "We build and manage dedicated engineering teams that align with your mission, culture, and processes—helping you overcome
                  talent shortages, scale effortlessly, and drive innovation with global expertise and Indian excellence."
                </p>

                {/* <div className="d-flex align-items-center gap-3">
                  <div className="home-avatar rounded-circle d-flex align-items-center justify-content-center text-white fw-bold">
                    CTO
                  </div>
                  <div>
                    <p className="home-testimonial-name fw-semibold mb-0">European Tech Company</p>
                    <p className="home-testimonial-role text-muted small">Chief Technology Officer</p>
                  </div>
                </div> */}

                {/* Floating Retention Stat */}
                <motion.div
                  animate={{ y: [0, -12, 0] }}
                  transition={{ duration: 3.8, repeat: Infinity, ease: "easeInOut" }}
                  className="home-floating-stat"
                  style={{ top: "-45px", right: "-30px" }}   // Moved higher and further right
                >
                  <div className="home-stat-card-inner">
                    <span className="home-stat-number1">100%</span>
                    <p className="home-stat-label1">Retention Rate</p>
                  </div>
                </motion.div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>


      {/* ===== STATS COUNTER BANNER ===== */}
      <section className="home-stats-banner py-5 py-lg-6 position-relative overflow-hidden">
        {/* Background */}
        <div className="home-stats-bg-gradient" />
        <div className="home-stats-grid" />

        {/* Glowing Orbs */}
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.15, 0.25, 0.15] }}
          transition={{ duration: 4, repeat: Infinity }}
          className="home-glowing-orb orb-1"
        />
        <motion.div
          animate={{ scale: [1.2, 1, 1.2], opacity: [0.1, 0.2, 0.1] }}
          transition={{ duration: 5, repeat: Infinity }}
          className="home-glowing-orb orb-2"
        />

        <Container className="position-relative">
          <div className="text-center mb-5">
            <h2 className="home-stats-title fw-bold mb-3 text-white">
              Speed Up Development & Innovation With Us
            </h2>
            <p className="home-stats-subtitle text-white-75 mx-auto" style={{ maxWidth: "620px" }}>
              Digital Engineering through value driven, customer focused, and design thinking approach.
            </p>
          </div>

          <Row className="g-4">
            {[
              { target: 7, suffix: "+", label: "Countries ", icon: FiGlobe },
              { target: 150, suffix: "+", label: "Headcount", icon: FiUsers },
              { target: 40, suffix: "+", label: "Satisfied Clients", icon: FiHeart },
              { target: 100, suffix: "%", label: "Client Retention", icon: FiAward },
            ].map((s, i) => (
              <Col key={i} sm={6} md={3}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  whileHover={{ y: -6, scale: 1.03 }}
                  className="home-stat-card text-center p-4 rounded-4 border border-white/10"
                >
                  <div className="home-stat-icon-wrapper mx-auto mb-4">
                    <s.icon size={32} />
                  </div>

                  {/* Counting Animation */}
                  <Counter target={s.target} suffix={s.suffix} />

                  <div className="home-stat-label">{s.label}</div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ===== CASE STUDIES ===== */}
      <section className="home-case-studies py-5 py-lg-6 position-relative overflow-hidden bg-light">
        <Container>
          <div className="text-center mb-5">
            <div className="home-case-badge d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill mb-3">
              <IoBarChart size={16} /> Success Stories
            </div>
            <h2 className="home-case-title fw-bold mb-3">
              Case <span className="home-highlight">Studies</span>
            </h2>
          </div>

          <Row className="g-4">
            {caseStudies.map((cs, i) => (
              <Col key={i} sm={6} lg={4}>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  whileHover={{ y: -8 }}
                  className="home-case-card h-100 position-relative overflow-hidden border rounded-4 p-4 p-lg-5"
                >
                  {/* Top Accent Bar */}
                  <div className="home-case-top-bar" />

                  {/* Decorative Corner */}
                  <div className="home-case-corner" />

                  <div className="relative">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <span className="home-case-tag">{cs.tag}</span>
                      <span className="home-case-industry">{cs.industry}</span>
                    </div>

                    <h3 className="home-case-title-card fw-bold mb-3">{cs.title}</h3>
                    <p className="home-case-result fw-semibold mb-4">{cs.result}</p>

                    <Link
                      to="/insights/case-study"
                      className="home-case-read-more text-decoration-none d-inline-flex align-items-center gap-2 fw-semibold"
                    >
                      Read Full Case Study <FiArrowUpRight size={16} />
                    </Link>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default Home;